import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const BoxBody = styled(Box)<BoxProps>(({ theme }) => ({
  position: "relative",
  isolation: "isolate",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  minHeight: "100%",
  padding: theme.spacing(4, 4, 3),
  overflow: "visible",
  overflowX: "hidden",
  scrollBehavior: "smooth",
  backgroundColor: "#F7F9FC",
  backgroundImage:
    "radial-gradient(circle at 92% 8%, rgba(0, 217, 255, 0.16), transparent 25%), radial-gradient(circle at 8% 92%, rgba(108, 92, 231, 0.1), transparent 28%)",
  "&::before": {
    content: "\"\"",
    position: "absolute",
    inset: 0,
    zIndex: -1,
    pointerEvents: "none",
    opacity: 0.42,
    backgroundImage:
      "radial-gradient(rgba(1, 77, 223, 0.13) 1px, transparent 1px)",
    backgroundSize: "28px 28px",
    maskImage: "linear-gradient(to bottom, black, transparent 72%)",
  },
  [theme.breakpoints.down("md")]: {
    minHeight: "auto",
    padding: theme.spacing(2, 2, 7),
  },
  [theme.breakpoints.up("md")]: {
    height: "100vh",
    padding: theme.spacing(4, 4, 3),
  },
}));
